import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ExtractFromLoadService } from '../extract-from-load.service';

@Component({
  selector: 'app-extract-cloud',
  templateUrl: './extract-cloud.component.html'
})
export class ExtractCloudComponent implements OnInit {
  public selectButtonProperties: string = "black";
 
  public extractEnable: boolean = false;
  
  public submitButtonProperties: string = "";
  public buttonClass: string = "nextbuttonBefore";
  
  public popupVariable: boolean = false;
  public batchKey: any;
  public hideOptions: boolean = false;
  constructor(public dialog: MatDialog,private celService: ExtractFromLoadService) {}

  ngOnInit(): void {

  }
}